export default __webpack_public_path__ + "static/media/npm.8dcb123d.png";